// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Attachments_wrapper__1Qz6t","group":"Attachments_group__1jb8T"};